import React from "react";

type Row = {
  label: string;
  content: React.ReactNode;
};

type MobileExpandedRowProps = {
  rows: Row[];
};

export const MobileExpandedRow = ({ rows }: MobileExpandedRowProps) => {
  return (
    <div className="flex flex-col gap-4 px-4 py-2">
      {rows.map(({ label, content }) => (
        <div key={label}>
          <div className="text-xs uppercase font-bold">{label}</div>
          <div className="text-sm mt-1">{content}</div>
        </div>
      ))}
    </div>
  );
};
